export { default } from "../../components/CDP/Anonymous/Registered";
